import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMclarenComponent } from './simple-icons-mclaren.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMclarenComponent ],
    exports:      [ SimpleIconsMclarenComponent ],
    bootstrap:    []
})
export class SimpleIconsMclarenModule {}
